import { useEffect, useState } from 'react'
import { publicMcpAddress } from '../experience'

/** The MCP address from the server (publicMcpAddress): `url` once read; `failed` when the server has none. */
export function useMcpAddress(): { url: string | null; failed: boolean } {
  const [state, setState] = useState<{ url: string | null; failed: boolean }>({ url: null, failed: false })
  useEffect(() => {
    let cancelled = false
    publicMcpAddress().then((url) => { if (!cancelled) setState({ url, failed: false }) }).catch(() => { if (!cancelled) setState({ url: null, failed: true }) })
    return () => { cancelled = true }
  }, [])
  return state
}

/** What a Connect control shows while the address is unread or missing. */
export const MCP_ADDRESS_FAILED = 'No MCP address'
